import { createMuiTheme, MuiThemeProvider, Typography, withStyles, Tooltip, TableCell, Snackbar, Switch } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { useEffect, useReducer, useState } from "react";
import api from "../api";
import MuiAlert from '@material-ui/lab/Alert';
import CloseImage from '../../assets/ic_close.png';
import icFilter from '../../assets/ic_filter.png';
import Loader from 'react-loader-spinner'
import FilterDataFasilitas from "./FilterDataFasilitas";
import ReactExport from 'react-data-export';
import ic_downloadFile from '../../assets/ic_downloadFile.png';
import { format } from 'date-fns';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());

const options = ct.customOptions()
const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const style = {
    position: "sticky",
    zIndex: 110
};

export default function LeadTimeFasilitas(props) {
    const [dataTable, setDataTable] = useState([])
    const [dataUser, setDataUser] = useState([])
    const [dataFacilityCategory, setDataFacilityCategory] = useState([])
    const [dataFacility, setDataFacility] = useState([])
    const [dataSubfacility, setDataSubfacility] = useState([])
    const [id, setID] = useState("")
    const [visibleCreate, setVisibleCreate] = useState(false)
    const [detail, setDetail] = useState([])
    const [visibleEdit, setVisibleEdit] = useState(false)
    const [visibleStatus, setVisibleStatus] = useState(false)
    const [messageAlert, setMessageAlert] = useState("")
    const [statusAlert, setStatusAlert] = useState("")
    const [openAlert, setOpenAlert] = useState(false);
    const [error, setError] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [create, setCreate] = useState(false);
    const [read, setRead] = useState(false);
    const [update, setUpdate] = useState(false);
    const [deleted, setDeleted] = useState(false);
    const [loading, setLoading] = useState(false)
    const [average, setAverage] = useState(null)
    const [saveUser, setSaveUser] = useState(null)
    const [saveTglMulai, setSaveTglMulai] = useState(null)
    const [saveTglSelesai, setSaveTglSelesai] = useState(null)
    const [saveCategory, setSaveCategory] = useState([])
    const [saveFacility, setSaveFacility] = useState([])
    const [saveSubFacility, setSaveSubFacility] = useState([])
    const [multiDataSet, setMultiData] = useState([])
    const [download, setDownload] = useState(false)

    useEffect(() => {
        getPermission(props)
        getUser()
        getFacilityCategory()
        getFacility()
        getSubfacility()
    }, [])

    const getPermission = (e) => {
        api.create().getPermission(e.menuid).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setCreate(data.create)
                    setUpdate(data.update)
                    setRead(data.read)
                    setDeleted(data.delete)
                }
            }
        })
    }

    const getUser = () => {
        api.create().getUserLTP().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = []
                    response.data.data.users.map((item) => {
                        data.push(item)
                    })
                    setDataUser(data)
                } else {
                    setDataUser([])
                }
            }
        })
    }

    const getFacilityCategory = () => {
        api.create().getFacilityCategory().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data.length > 0) {
                        let data = []
                        response.data.data.map((item) => {
                            if (item.deleted_at === null) {
                                data.push(item)
                            }
                        })
                        setDataFacilityCategory(data)
                    } else {
                        setDataFacilityCategory([])
                    }
                }
            }
        })
    }

    const getFacility = () => {
        api.create().getAllFacility().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data.length > 0) {
                        let data = []
                        response.data.data.map((item) => {
                            if (item.status === 1) {
                                data.push(item)
                            }
                        })
                        setDataFacility(data)
                    } else {
                        setDataFacility([])
                    }
                }
            }
        })
    }

    const getSubfacility = () => {
        api.create().getAllSubFacility().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data.length > 0) {
                        let data = []
                        response.data.data.map((item) => {
                            if (item.deleted_at === null) {
                                data.push(item)
                            }
                        })
                        setDataSubfacility(data)
                    } else {
                        setDataSubfacility([])
                    }
                }
            }
        })
    }

    const handleFilter = (payload, tglMulai, tglSelesai) => {
        api.create().LTPFacility(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.message !== "Data not found!") {
                        let dataTable = response.data.data.details.map((item, index) => {
                            return [
                                item.queue_date,
                                item.user_name,
                                item.patient_name === null ? '' : item.patient_name,
                                item.payment_option_name,
                                item.queue_number === null ? '' : item.queue_number,
                                item.facility_category_name,
                                item.facility_name,
                                item.sub_facility_name,
                                item.waiting_start_time,
                                item.waiting_end_time,
                                item.waiting_duration,
                                item.service_start_time,
                                item.service_end_time,
                                item.service_duration,
                                item.other_notes
                            ]
                        })
                        setAverage(response.data.data.average)
                        setDataTable(dataTable)
                        setVisibleCreate(false)
                        let judul = [
                            { title: `Data ini di unduh pada ${format(new Date(), 'dd MMM yyyy, HH:mm:ss')}` }
                        ]
                        let subJudul = [
                            [{ value: `filter by Nama user : ${props.nama}, Tanggal Mulai ${format(new Date(tglMulai), 'dd MM yyyy')}, Tanggal Akhir ${format(new Date(tglSelesai), 'dd MM yyyy')}` }]
                        ]
                        let data = []
                        let column = [
                            { title: "Tanggal", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                            { title: "Nama User", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                            { title: "Nama Pasien", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                            { title: "Opsi Pembayaran", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                            { title: "No Antrian", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                            { title: "Fasilitas Kategori", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                            { title: "Fasilitas", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                            { title: "Sub Fasilitas", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                            { title: "Waiting Start Time", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                            { title: "Waiting End Time", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                            { title: "Waiting Durasi", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                            { title: "Service Start Time", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                            { title: "Service End Time", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                            { title: "Service Durasi", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                            { title: "Catatan Antrian", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                        ]
                        response.data.data.details.map((item) => {
                            data.push([
                                { value: item.queue_date },
                                { value: item.user_name },
                                { value: item.patient_name === null ? '' : item.patient_name },
                                { value: item.payment_option_name === null ? '' : item.payment_option_name },
                                { value: item.queue_number === null ? '' : item.queue_number },
                                { value: item.facility_category_name === null ? '' : item.facility_category_name },
                                { value: item.facility_name === null ? '' : item.facility_name },
                                { value: item.sub_facility_name === null ? '' : item.sub_facility_name },
                                { value: item.waiting_start_time === null ? '' : item.waiting_start_time },
                                { value: item.waiting_end_time === null ? '' : item.waiting_end_time },
                                { value: item.waiting_duration === null ? '' : item.waiting_duration },
                                { value: item.service_start_time === null ? '' : item.service_start_time },
                                { value: item.service_end_time === null ? '' : item.service_end_time },
                                { value: item.service_duration === null ? '' : item.service_duration },
                                { value: item.other_notes === null ? '' : item.other_notes },
                            ])
                        })
                        let dataJadi = [
                            {
                                columns: judul,
                                data: subJudul
                            },
                            {
                                columns: column,
                                data: data
                            }
                        ]
                        setDownload(true)
                        setMultiData(dataJadi)
                        forceUpdate()
                    } else {
                        setDownload(false)
                        setAverage(null)
                        setDataTable([])
                        setVisibleCreate(false)
                        forceUpdate()
                    }
                }
            }
        })
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    const forceUpdate = useReducer(bool => !bool)[1];

    const columns = [{
        name: "Tanggal",
        options: {
            sort: true,
            customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                    <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                </TableCell>
            ),
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ display: 'flex', textAlign: 'left' }}>
                        {val}
                    </div>
                )
            }
        }
    }, {
        name: "Nama User",
        options: {
            sort: true,
            customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                    <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                </TableCell>
            ),
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ display: 'flex', textAlign: 'left' }}>
                        {val}
                    </div>
                )
            }
        }
    }, {
        name: "Nama Pasien",
        options: {
            sort: true,
            customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                    <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                </TableCell>
            ),
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ display: 'flex', textAlign: 'left' }}>
                        {val}
                    </div>
                )
            }
        }
    }, {
        name: "Opsi Pembayaran",
        options: {
            sort: true,
            customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                    <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                </TableCell>
            ),
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ display: 'flex', textAlign: 'left' }}>
                        {val}
                    </div>
                )
            }
        }
    }, {
        name: "No Antrian",
        options: {
            sort: true,
            customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                    <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                </TableCell>
            ),
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ display: 'flex', textAlign: 'left' }}>
                        {val}
                    </div>
                )
            }
        }
    }, {
        name: "Fasilitas Kategori",
        options: {
            sort: true,
            customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                    <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                </TableCell>
            ),
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ display: 'flex', textAlign: 'left' }}>
                        {val}
                    </div>
                )
            }
        }
    }, {
        name: "Fasilitas",
        options: {
            sort: true,
            customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                    <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                </TableCell>
            ),
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ display: 'flex', textAlign: 'left' }}>
                        {val}
                    </div>
                )
            }
        }
    }, {
        name: "Sub Fasilitas",
        options: {
            sort: true,
            customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                    <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                </TableCell>
            ),
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ display: 'flex', textAlign: 'left' }}>
                        {val}
                    </div>
                )
            }
        }
    }, {
        name: "Waiting Start Time",
        options: {
            sort: true,
            customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                    <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                </TableCell>
            ),
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ display: 'flex', textAlign: 'left' }}>
                        {val}
                    </div>
                )
            }
        }
    }, {
        name: "Waiting End Time",
        options: {
            sort: true,
            customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                    <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                </TableCell>
            ),
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ display: 'flex', textAlign: 'left' }}>
                        {val}
                    </div>
                )
            }
        }
    }, {
        name: "Waiting Duration",
        options: {
            sort: true,
            customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                    <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                </TableCell>
            ),
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ display: 'flex', textAlign: 'left' }}>
                        <Typography style={{ fontWeight: 'bold' }}>{val}</Typography>
                    </div>
                )
            }
        }
    }, {
        name: "Service Start Time",
        options: {
            sort: true,
            customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                    <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                </TableCell>
            ),
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ display: 'flex', textAlign: 'left' }}>
                        {val}
                    </div>
                )
            }
        }
    }, {
        name: "Service End Time",
        options: {
            sort: true,
            customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                    <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                </TableCell>
            ),
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ display: 'flex', textAlign: 'left' }}>
                        {val}
                    </div>
                )
            }
        }
    }, {
        name: "Service Duration",
        options: {
            sort: true,
            customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                    <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                </TableCell>
            ),
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ display: 'flex', textAlign: 'left' }}>
                        <Typography style={{ fontWeight: 'bold' }}>{val}</Typography>
                    </div>
                )
            }
        }
    }, {
        name: "Catatan Antrian",
        options: {
            sort: true,
            customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                    <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                </TableCell>
            ),
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ display: 'flex', textAlign: 'left' }}>
                        {val}
                    </div>
                )
            }
        }
    }, {
        name: "",
        options: {
            display: false,
            filter: false
        }
    }];

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 110, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    return (
        <div style={{ paddingTop: 10, position: 'relative' }}>
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            {loading ? loadingComponent : null}
            <div style={{ width: '100%', display: 'flex', margin: '5px 0', justifyContent: 'space-between', position: 'relative' }}>
                <div style={{ display: 'flex' }}>
                    <button style={{ padding: '5px 10px', backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', borderColor: 'transparent', outline: 'none' }}
                        onClick={() => setVisibleCreate(true)}
                    >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <img style={{ width: 16, height: 16, marginRight: 7 }} src={icFilter} />
                            <Typography style={{ fontSize: 14, margin: 'auto', margin: '0 3px', color: 'white' }}>Filter Data</Typography>
                        </div>
                    </button>
                    {average !== null && (
                        <div style={{ marginLeft: 20, display: 'flex' }}>
                            <div style={{ width: 30, height: 10, borderRadius: 10, backgroundColor: '#278863', margin: '5px 13px 0 0' }} />
                            <div>
                                <Typography style={{ fontSize: 14, color: '#868686' }}>Waktu Tunggu</Typography>
                                <Typography style={{ fontSize: 18, color: '#000000', fontWeight: '500', lineHeight: 1 }}>{average.waiting_time}</Typography>
                            </div>
                        </div>
                    )}
                    {average !== null && (
                        <div style={{ marginLeft: 20, display: 'flex' }}>
                            <div style={{ width: 30, height: 10, borderRadius: 10, backgroundColor: '#49ea6e', margin: '5px 13px 0 0' }} />
                            <div>
                                <Typography style={{ fontSize: 14, color: '#868686' }}>Waktu Layanan</Typography>
                                <Typography style={{ fontSize: 18, color: '#000000', fontWeight: '500', lineHeight: 1 }}>{average.service_time}</Typography>
                            </div>
                        </div>
                    )}
                </div>
                {download && (
                    <div style={{ alignSelf: 'center', position: 'absolute', top: 63, right: 100, zIndex: 2 }}>
                        <ExcelFile
                            element={
                                <LightTooltip title={"Download Data"} arrow>
                                    <div style={{ cursor: 'pointer', display: 'flex' }}>
                                        <img src={ic_downloadFile} style={{ width: 24, height: 24, marginRight: 16 }} />
                                    </div>
                                </LightTooltip>
                            }
                            filename={`Report Fasilitas ${format(new Date(saveTglMulai), 'dd-MM-yyyy')} - ${format(new Date(saveTglSelesai), 'dd-MM-yyyy')}`}
                        >
                            <ExcelSheet dataSet={multiDataSet} name="Sheet" />
                        </ExcelFile>
                    </div>
                )}
            </div>
            <div >
                <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        data={dataTable}
                        columns={columns}
                        options={options}
                    />
                </MuiThemeProvider>
            </div>

            {visibleCreate && (
                <FilterDataFasilitas
                    onClose={() => setVisibleCreate(false)}
                    dataUser={dataUser}
                    dataFacilityCategory={dataFacilityCategory}
                    dataFacility={dataFacility}
                    dataSubfacility={dataSubfacility}
                    saveUser={saveUser}
                    saveTglMulai={saveTglMulai}
                    saveTglSelesai={saveTglSelesai}
                    saveCategory={saveCategory}
                    saveFacility={saveFacility}
                    saveSubFacility={saveSubFacility}
                    handleFilter={(payload, user, tglMulai, tglSelesai, cat, facility, subfacility) => {
                        handleFilter(payload, tglMulai, tglSelesai)
                        setSaveUser(user)
                        setSaveTglMulai(tglMulai)
                        setSaveTglSelesai(tglSelesai)
                        setSaveCategory(cat)
                        setSaveFacility(facility)
                        setSaveSubFacility(subfacility)
                        forceUpdate()
                    }}
                />
            )}

        </div>
    )
}